
import { defineComponent } from "vue";
export default defineComponent({
  name: "exchange-fields",
  props: {
    currencyList: Array,
    currencyInput: Number,
    currency: String,
    disabledInput: Boolean,
  },
  emits: ["update:currencyInput", "update:currency"],
});
